import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent, PropsWithChildren } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { EditDialog, EditDialogProps } from '../EditDialog/EditDialog';
export type SingleTabEditDialogProps = Omit<EditDialogProps<'general'>, 'activeTabName' | 'onTabSelected' | 'children'> & PropsWithChildren & {
  tabTitle: string;
};

/**
 * This is a wrapper for the EditDialog for usages which only need one tab, so you don't have to configure that much
 */
export const SingleTabEditDialog: FunctionComponent<SingleTabEditDialogProps> = React.memo(props => {
  const $ = _c(12);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let children;
  let remainingProps;
  let tabTitle;
  if ($[2] !== t0) {
    ({
      tabTitle,
      children,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = children;
    $[4] = remainingProps;
    $[5] = tabTitle;
  } else {
    children = $[3];
    remainingProps = $[4];
    tabTitle = $[5];
  }
  let t1;
  if ($[6] !== children || $[7] !== tabTitle) {
    t1 = () => ({
      general: {
        name: "general",
        title: tabTitle,
        renderContent: () => children
      }
    });
    $[6] = children;
    $[7] = tabTitle;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== remainingProps || $[10] !== t1) {
    t2 = <EditDialog {...remainingProps} activeTabName="general">{t1}</EditDialog>;
    $[9] = remainingProps;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
});